import { useCallback, useState } from 'react'

import { gtm } from '@Globals/Google/DataLayer'
import { useNewsletterSubscription } from '@Globals/Newsletter/useNewsletterSubscription'

export const useCheckoutSubscribeToMail = () => {
  const [subscribeSent, setSubscribeSent] = useState<boolean>(false)
  const { subscribe } = useNewsletterSubscription()
  const subscribeToNewsLetter = useCallback((email: string) => {
    if (!subscribeSent) {
      gtm({
        event: 'newsletterSignUp',
      })
      subscribe({ email, source: 'checkout' })
      setSubscribeSent(true)
    }
  }, [subscribe, subscribeSent])

  return { subscribe: subscribeToNewsLetter }
}
